import graphql__018ca0c02a66918646cf from "./__generated__/ThemeFilter_participativeModule.graphql.js";import { useMemo, useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { useDispatch } from "react-redux";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useFormatMessage } from "../Intl/Context";
import { useResourcesList } from "../ResourcesList/resourcesList";

import { updateSelectedThemes } from "../../reducers/resourcesList/search";
import Select from "../Select/Select";
import { selectOptionsWithColorStyles } from "../Select/selectOptionsWithColorStyles";

const ThemeFilter = props => {
  const dispatch = useDispatch();

  const { themes } = useFragment(
    ThemeFilter_participativeModule,
    props.participativeModule
  );

  const t = useFormatMessage();
  const themeLabel = t(intlMessages.theme);

  const className = classNames([
    "react-select",
    "filter",
    "theme-filter",
    "nowrap",
    props.className
  ]);

  const { resourcesListKey } = useResourcesList();

  const handleChanged = useCallback(
    option => {
      const theme = option && themes.find(({ id }) => option.value === id);
      const newSelectedThemes = theme ? [theme] : [];

      dispatch(updateSelectedThemes(resourcesListKey, newSelectedThemes));
    },
    [dispatch, resourcesListKey, themes]
  );

  const themeOptions = useMemo(
    () =>
      themes.map(
        ({
          id: value,
          name: label,
          primaryColor: color,
          primaryContrastColor: foregroundColor
        }) => ({
          label,
          value,
          color,
          foregroundColor
        })
      ),
    [themes]
  );

  // Do not display the filter if the participative module has no themes
  if (themes.length === 0) return null;

  return (
    <Select
      className={className}
      classNamePrefix="react-select"
      options={themeOptions}
      onChange={handleChanged}
      styles={selectOptionsWithColorStyles}
      placeholder={themeLabel}
      isClearable={true}
      aria-label={themeLabel}
    />
  );
};

const ThemeFilter_participativeModule = graphql__018ca0c02a66918646cf;

export default ThemeFilter;

const intlMessages = defineMessages({
  theme: {
    id: "filters.theme",
    defaultMessage: "Filtrer par thématique"
  }
});
